import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface InformationCardContentTopSite {
  description: string;
  id: string;
}

const InformationCardContentTopSite: React.FC<InformationCardContentTopSite> = ({ description, id }) => {
  const { t } = useTranslation();

  const kpi = useSelector((state: any) => state.kpi);
  const costsRanking = kpi?.costsRanking;

  if ( costsRanking?.length === 0 ) { return null }

  return (
    <>
      <span key={`${id}-label_1`} className="paragraph">
        -.- { costsRanking?.[0]?.rankings?.[0]?.siteName }
      </span>
      <span key={`${id}-label_2`} className="paragraph">
      {t(description)}
        
      </span>
    </>
  );
};

export default InformationCardContentTopSite; 